// FAQ.js
import React, { useState } from "react";
import { Accordion, Container } from "react-bootstrap";
import { FaPlus, FaMinus, FaQuestionCircle } from "react-icons/fa";

const faqData = [
    {
        question: "Mauris blandit aliquet elit, eget tincidunt nibh pulvinar?",
        answer:
            "Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Vestibulum tortor quam, feugiat vitae, ultricies eget, tempor sit amet, ante.",
    },
    {
        question: "Curabitur arcu erat, accumsan id imperdiet et, porttitor at sem?",
        answer: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
    },
    {
        question: "Vestibulum ante ipsum primis in faucibus orci luctus?",
        answer: "Donec sollicitudin molestie malesuada.",
    },
    {
        question: "Nulla facilisi morbi tempus iaculis urna id volutpat?",
        answer: "Curabitur non nulla sit amet nisl tempus convallis quis ac lectus.",
    },
];

const FAQ = () => {
    const [activeKey, setActiveKey] = useState("0");

    const toggleAccordion = (key) => {
        setActiveKey(activeKey === key ? null : key);
    };

    return (
        <Container className="my-3">
            {/* Heading */}
            <div className="text-center mb-5">
                <h2 className="fw-bold">F.A.Q</h2>
                <div
                    style={{
                        width: "60px",
                        height: "3px",
                        backgroundColor: "#F89A33",
                        margin: "10px auto",
                    }}
                ></div>
                <p className="text-muted">Frequently Asked Questions</p>
            </div>

            {/* Accordion */}
            <Accordion activeKey={activeKey}>
                {faqData.map((faq, index) => (
                    <Accordion.Item
                        key={index}
                        eventKey={String(index)}
                        className="mb-3 shadow-sm border-menu rounded-2 "
                        style={{ overflow: "hidden" }}
                    >
                        <Accordion.Header
                            onClick={() => toggleAccordion(String(index))}
                            className="d-flex justify-content-between align-items-center custom-accordion-header"
                        >
                            {/* Left Side - Icon + Question */}
                            <div className="d-flex align-items-center">
                                <FaQuestionCircle
                                    size={22}
                                    className="me-3"
                                    style={{
                                        color: activeKey === String(index) ? "white" : "#ffae00 !important",
                                        background: activeKey === String(index) ? "#ffae00 !important" : "#ffae00",
                                        borderRadius: "50%",
                                        padding: "4px",
                                        color: "white",
                                    }}
                                />
                                <span
                                    className="fw-semibold"
                                    style={{
                                        color: activeKey === String(index) ? "#ffae00 !important" : "#ffae00 ",
                                    }}
                                >
                                    {faq.question}
                                </span>
                            </div>

                            {/* Right Side - Plus/Minus */}
                            <div className="ms-auto">
                                {activeKey === String(index) ? (
                                    <FaMinus
                                        size={18}
                                        style={{
                                            color: "white",
                                            backgroundColor: "#fe6600",
                                            borderRadius: "50%",
                                            padding: "4px",
                                        }}
                                    />
                                ) : (
                                    <FaPlus
                                        size={18}
                                        style={{
                                            color: "white",
                                            backgroundColor: "#fe6600",
                                            borderRadius: "50%",
                                            padding: "4px",
                                        }}
                                    />
                                )}
                            </div>
                        </Accordion.Header>

                        {/* Answer */}
                        <Accordion.Body>
                            <p className="text-muted">{faq.answer}</p>
                        </Accordion.Body>
                    </Accordion.Item>
                ))}
            </Accordion>
        </Container>
    );
};

export default FAQ;
